import curd from '../curd'

const BASE_PATH = '/auto/audit/config'

export default curd(BASE_PATH)



// WEBPACK FOOTER //
// ./src/apis/modules/AuditConfig.js